import * as React from 'react';
import { styled } from '../../theme';

export interface PageHeadingWidgetProps {
  title: string;
  className?: any;
  extra?: React.JSX.Element | null;
}

export const PageHeadingWidget: React.FC<PageHeadingWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      <S.Content>
        <S.Title>{props.title}</S.Title>
        {props.extra || null}
      </S.Content>
      <S.Divider />
    </S.Container>
  );
};

namespace S {
  export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `;

  export const Container = styled.div`
    padding-bottom: 24px;
    user-select: none;
  `;

  export const Title = styled.div`
    color: ${(p) => p.theme.text.primary};
    font-size: 32px;
    font-weight: 600;
    padding-right: 10px;
  `;

  export const Divider = styled.div`
    background-color: ${(p) => p.theme.header.background};
    margin-top: 8px;
    height: 2px;
    width: 100%;
  `;
}
